
import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const Header: React.FC = () => {
  const [userMetadata, setUserMetadata] = useState<any>(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) setUserMetadata(user.user_metadata);
    };

    fetchUser();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) setUserMetadata(session.user.user_metadata);
      else setUserMetadata(null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const avatarUrl = userMetadata?.avatar_url || "https://ui-avatars.com/api/?name=Admin&background=3b82f6&color=fff";
  const displayName = userMetadata?.full_name || "Portal Admin";

  return (
    <header className="h-20 bg-[#020617]/40 backdrop-blur-3xl border-b border-white/5 flex items-center justify-between px-10 z-20">
      <div className="flex items-center space-x-6 flex-1">
        <div className="relative group max-w-md w-full">
          <input 
            type="text" 
            placeholder="Search library..." 
            className="w-full bg-white/5 border border-white/5 text-sm rounded-2xl py-3 pl-12 pr-4 focus:outline-none focus:ring-2 focus:ring-accent-blue/30 focus:bg-white/10 transition-all placeholder-slate-600 font-medium"
          />
          <i className="fas fa-search absolute left-5 top-1/2 -translate-y-1/2 text-slate-600 text-xs transition-colors group-focus-within:text-accent-blue"></i>
        </div>
      </div>

      <div className="flex items-center space-x-8">
        <div className="flex items-center space-x-4 pr-6 border-r border-white/10">
           <button className="w-10 h-10 rounded-xl flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/5 transition-all">
             <i className="far fa-bell text-lg"></i>
           </button>
           <button className="w-10 h-10 rounded-xl flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/5 transition-all">
             <i className="far fa-message text-lg"></i>
           </button>
        </div>
        
        <div className="flex items-center space-x-4 pl-2 group cursor-pointer">
          <div className="text-right">
            <p className="text-sm font-extrabold text-white tracking-tight">{displayName}</p>
            <div className="flex items-center justify-end space-x-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-cyan animate-pulse"></span>
              <p className="text-[10px] text-accent-cyan font-black uppercase tracking-[0.2em]">Active</p>
            </div>
          </div>
          <div className="relative">
            <div className="w-11 h-11 rounded-2xl bg-gradient-to-tr from-accent-blue to-accent-purple p-[1px] shadow-xl shadow-accent-blue/10 transform transition-transform group-hover:scale-105">
              <img 
                src={avatarUrl} 
                alt="Admin" 
                className="w-full h-full rounded-[15px] object-cover border-[2px] border-[#020617]"
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
